import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-719e6bfb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "TextLogicalReasoningQuestionSelectorContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "文字推理", -1));
const _hoisted_3 = {
  class: "mr-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_TextLogicalReasoningQuestion = _resolveComponent("TextLogicalReasoningQuestion");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg colFlex wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        "group-title": "文字推理分组",
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 colFlex"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: q.id,
          class: "wbg mb12 p-2",
          style: {
            "border": "#1388ff 1px dashed"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString(qi + 1) + "题 答案：" + _toDisplayString(q.rightAnswer), 1), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $event => $options.confirm(q.id)
            }, {
              default: _withCtx(() => [_createTextVNode("选择此题")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024), _createVNode(_component_TextLogicalReasoningQuestion, {
            question: q
          }, null, 8, ["question"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })]);
}